<template>
  <div>
    <div class="file-list">
      <div class="file-item" :class="{'border-right': i !== list.length-1 && (i+1)%3 !==0}" v-for="(v, i) in list" :key="i">
        <img class="bg-img" :src="v.imgUrl||'/a'" @error="imgError('/img/fileimg.png')">
        <a class="shade-btn hidden-xs-only">
          <!-- <div class="file-title-top txt-line-2">{{v.title}}</div> -->
          <a class="ds-btn" target="_blank" :href="v.fileUrl"><i class="el-icon-search"></i>预览</a>
        </a>
        <div class="file-title txt-line-2">{{v.title}}</div>
        <div class="down-btn hidden-xs-only"><a target="_blank" :href="v.fileUrl" :download="v.fileName">下载 > </a></div>
        <div class="down-btn hide-pc"><a target="_blank" :href="v.fileUrl" :download="v.fileName">了解详情 > </a></div>
      </div>
    </div>
    <div class="project-pagination-wrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :pager-count="5"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {imgError} from '@/assets/utility.js'
import {getArticleListByColId} from '@/api/project'

export default {
  props: {
    colid: String
  },
  data() {
    return {
      list: [],
      currentPage: 1,
      pageSize: 30,
      total: 0
    }
  },
  mounted() {
    
  },
  methods: {
    loadData(pId) {
      getArticleListByColId(pId, this.currentPage, this.pageSize).then(res => {
        if (res) {
          this.list = res.rows
          this.total = res.total - 0
        }
      })
    },
    handleCurrentChange(e) {
      this.currentPage = e
      this.loadData(this.colid)
    },
    imgError(pUrl) {
      imgError(pUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
  .file-list {
    display: flex;
    flex-wrap: wrap;
    .file-item {
      position: relative;
      
      .shade-btn {
        position: absolute;
        top: 0;
        left: 0;
        display: none;
        //width: 100%;
        width: rem(526);
        background-color: rgba(#fff, .9);
        animation: 1s fadeInOut;
        .file-title-top {
          position: absolute;
          bottom: 0;
          width: 100%;
          text-align: left;
          transition: bottom .8s;
        }
        .file-title-top::before {
          content: '';
          display: block;
          height: 2px;
          background-color: #999;
        }
        .ds-btn {
          position: absolute;
          display: block;
          margin: auto;
          left: 0;
          right: 0;
        }
      }
      .file-title {
        text-align: left;
        color:#282828;
      }
      .down-btn a{
        text-align: left;
        color: #00653E;
      }
      .ds-btn {
        display: inline-block;
        text-align: center;
        color: #fff;
        background-color: #00653E;
      }
    }
  }
  @media only screen and (min-width: 768px) {
    .hide-pc {
      display: none;
    }
    .file-list {
      .file-item {
        margin-right: rem(40);
        margin-top: rem(71);
        padding-right: rem(40);
        width: rem(526);
        .bg-img {
          //height: rem(673);
          height: rem(328);
         // border-radius: rem(48);
        }
        .shade-btn {
          height: rem(328);
          width: rem(526);
          //border-radius: rem(48);
          .file-title-top {
            font-size: rem(34);
          }
          .file-title-top::before {
            margin: 0 auto rem(30) auto;
            width: rem(33);
          }
          .ds-btn {
            bottom: rem(74);
          }
        }
        .file-title {
          margin-bottom: rem(20);
          padding-top: rem(30);
          font-size: rem(26);
          font-weight: 400;
        }
        .down-btn > a, .ds-btn {
          width: rem(148);
          height: rem(49);
          line-height: rem(49);
          font-size: rem(18);
          border-radius: rem(25);
        }
      }
      .file-item:nth-child(3n) {
        margin-right: 0;
        padding-right: 0;
      }
      .file-item:hover {
        cursor: pointer;
        .shade-btn {
          display: block;
          // .file-title-top {
          //   bottom: rem(450);
          // }
        }
      }
    }
  }
  @media only screen and (max-width: 768px) {
    .hide-pc {
      display: block;
    }
    .file-list {
      .file-item {
        margin-right: .35rem;
        margin-top: .35rem;
        width: 3rem;
        .bg-img {
          height: 3.2rem;
          //border-radius: .25rem;
        }
        .file-title {
          margin-bottom: .35rem;
          padding-top: .35rem;
          font-size: .3rem;
          text-align: center;
          font-weight: bold;
        }
        .down-btn{
          text-align: center;
        }
        .down-btn > a {
          width: 2.14rem;
          height: 0.5rem;
          line-height: 0.5rem;
          font-size: .24rem;
          border-radius: .25rem;
        }
      }
      .file-item:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
</style>
